<section class="dynamic-chart-container">
    @if(beginRender && ( !apiErrorOccurred || ( apiErrorOccurred && isFieldSelected))){
    <!-- The inline style is for making the loading indicator fit inside the container -->
    <section [ngClass]="chartType+'-container'" class="dynamic-chart" style="position: relative;">
        <div class="header-container">
            <div class="chart-header-fields chart-header-element">
                <div class="header-alignment">
                    @if(infoFields){
                    @for(infoField of infoFields; track idx; let idx = $index){
                    <div class="info-field">
                        <span class="label">{{infoField['fieldLabel'] | camelCase}}:- </span>
                        @if (infoField['infoType'] === 'total' || infoField['infoType'] === 'count') {
                        <span class="value">{{ (infoField['value'] ?? 0) | number:'1.0-0' }}</span>
                        } @else {
                        <span class="value">{{infoField['value'] | camelCase}}</span>
                        }
                    </div>
                    }
                    }
                    <div class="chart-header-element">
                        @if(exportConfig){
                        <div class="chart-export-action">
                            <app-download-button [tableValues]="dataSource" (buttonClicked)="downloadActionOnClick()"
                                exportMessage="{{exportConfig.exportMessage}}"></app-download-button>
                        </div>
                        }
                    </div>
                </div>
                @if(filterSchema){
                <div class="filter-fields">
                    <app-form-container [dynamicFormArray]="filterSchema"></app-form-container>
                </div>
                }
            </div>
        </div>


        @defer (on immediate){
        @if(dataSource && dataSource.length>0){
        <div [id]="elementId">
            <highcharts-chart [id]="chartSchema.isPie  ? 'pieContainer':'dynamic-charts'"
                [callbackFunction]="chartOnRender" [Highcharts]="Highcharts" [options]="chartOptions"
                [(update)]="updateFlag"></highcharts-chart>
        </div>
        }@else{
        @if(apiErrorOccurred){
        <div class="dynamic-chart-error">
            @if(chartSchema['title']){
            <h5 class="title highcharts-title">{{chartSchema['title'] | camelCase}}</h5>
            }
            <div class="error-body">
                <i class="fa-lg fa-solid fa-triangle-exclamation"></i>
                <span class="no-data-found-message">{{errorResponse['someErrorOccured'] | camelCase}}</span>
            </div>
        </div>
        }
        @else{
        <div class="dynamic-chart-empty">
            @if(chartSchema['title']){
            <h5 class="title highcharts-title">{{chartSchema['title'] | camelCase}}</h5>
            }
            <span class="no-data-found-message">{{ errorResponse['noDataFound'] | camelCase}}</span>
        </div>
        }
        }
        }
        @if(isLoading){
        <div class="chart-skeleton-overlay">
            <app-loading-skeleton [count]="1" width="100%" height="100%" borderRadius="8px"></app-loading-skeleton>
        </div>
        }
    </section>
    }
    @else{
    <div class="dynamic-chart-error">
        <h5 class="title highcharts-title">{{chartSchema['title'] ?? ''| camelCase}}</h5>
        <div class="error-body">
            <i class="fa-lg fa-solid fa-triangle-exclamation"></i>
            <span class="no-data-found-message">{{errorResponse['someErrorOccured'] | camelCase }}</span>
        </div>

    </div>

    }
</section>